(function () {

  // ==========================
  // Accessibility: Manage focus
  // ==========================
  function manageSlideFocus(slick) {
    const $slides = $(slick.$slides);

    $slides.each(function () {
      const $slide = $(this);
      const isHidden = $slide.attr('aria-hidden') === 'true';

      const $focusables = $slide.find(
        'a, button, input, select, textarea, [tabindex]'
      );

      if (isHidden) {
        $focusables.attr('tabindex', '-1');
      } else {
        $focusables.removeAttr('tabindex');
      }
    });
  }

  // ==========================
  // Hide/Show Controls
  // ==========================
  function toggleControlsVisibility(slick, $toolbar) {
    const total = slick.slideCount || 0;
    const slidesToShow = slick.options.slidesToShow || 1;

    if (total <= slidesToShow) {
      $toolbar.find('.slick-prev-btn, .slick-next-btn').hide();
      $toolbar.find('.scroll-track').hide();
    } else {
      $toolbar.find('.slick-prev-btn, .slick-next-btn').show();
      $toolbar.find('.scroll-track').show();
    }
  }

  // ==========================
  // Initialize single slider
  // ==========================
  function initSlider($slider) {
    if (!$slider.length) return;
    if ($slider.hasClass('slick-initialized')) return;

    const $toolbar = $slider.next('.slider-toolbar');
    const $prevBtn = $toolbar.find('.slick-prev-btn');
    const $nextBtn = $toolbar.find('.slick-next-btn');
    const $track = $toolbar.find('.scroll-track');
    const $thumb = $toolbar.find('.scroll-thumb');

    // ----------------------
    // Arrow state
    // ----------------------
    function updateArrowState(slick) {
      const current = slick.currentSlide;
      const total = slick.slideCount;
      const slidesToShow = Math.floor(slick.options.slidesToShow);

      if (current <= 0) {
        $prevBtn.prop('disabled', true).addClass('disabled');
      } else {
        $prevBtn.prop('disabled', false).removeClass('disabled');
      }

      if (current >= total - slidesToShow) {
        $nextBtn.prop('disabled', true).addClass('disabled');
      } else {
        $nextBtn.prop('disabled', false).removeClass('disabled');
      }
    }

    // ----------------------
    // Slick events
    // ----------------------
    $slider.on('init reInit afterChange', function (e, slick, currentSlide) {
      const total = slick.slideCount;
      const slidesToShow = slick.options.slidesToShow;
      const current = (typeof currentSlide === 'number') ? currentSlide : slick.currentSlide;

      // Paging
      $toolbar.find('.pagingInfo').text(`${current + 1}/${total}`);

      // Accessibility
      manageSlideFocus(slick);

      // Arrow state
      updateArrowState(slick);

      // Hide/show controls
      toggleControlsVisibility(slick, $toolbar);

      // Scrollbar
      if ($track.length && $thumb.length) {
        const trackWidth = $track.width();
        const safeTotal = Math.max(total, slidesToShow);

        const thumbWidth = trackWidth * (slidesToShow / safeTotal);
        $thumb.width(thumbWidth);

        const maxIndex = Math.max(0, Math.ceil(total - slidesToShow));
        const maxMove = Math.max(0, trackWidth - thumbWidth);

        let left = maxIndex > 0
          ? (current / maxIndex) * maxMove
          : 0;

        left = Math.max(0, Math.min(maxMove, left));

        if (document.documentElement.dir === 'rtl') {
          $thumb.css({ right: left + 'px', left: '' });
        } else {
          $thumb.css({ left: left + 'px', right: '' });
        }
      }
    });

    $slider.on('beforeChange', function (e, slick) {
      manageSlideFocus(slick);
      updateArrowState(slick);
      toggleControlsVisibility(slick, $toolbar);
    });

    // ----------------------
    // Initialize Slick
    // ----------------------
    $slider.slick({
      rtl: document.documentElement.dir === 'rtl',
      slidesToShow: 4.5,
      slidesToScroll: 3,
      infinite: false,
      arrows: false,
      dots: false,
      speed: 400,
      swipeToSlide: true,
      accessibility: true,
      responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 6.1 } },
        { breakpoint: 1024, settings: { slidesToShow: 4.5 } },
        { breakpoint: 990,  settings: { slidesToShow: 3.2 } },
        { breakpoint: 750,  settings: { slidesToShow: 1.5 } },
        { breakpoint: 480,  settings: { slidesToShow: 1.5 } }
      ]
    });

    // ----------------------
    // Desktop fix
    // ----------------------
    setTimeout(() => {
      const slick = $slider.slick('getSlick');

      $slider.slick('setPosition');
      $slider.slick('refresh');

      manageSlideFocus(slick);
      updateArrowState(slick);
      toggleControlsVisibility(slick, $toolbar);
    }, 300);

    $(window).on('load resize', function () {
      $slider.slick('setPosition');
    });

    // ----------------------
    // Toolbar arrows
    // ----------------------
    $prevBtn.off('click').on('click', () => $slider.slick('slickPrev'));
    $nextBtn.off('click').on('click', () => $slider.slick('slickNext'));

    // ----------------------
    // Drag scrollbar
    // ----------------------
    let isDragging = false, startX = 0, startLeft = 0;

    function goToPercent(percent) {
      const slick = $slider.slick('getSlick');
      const maxIndex = Math.max(0, Math.ceil(slick.slideCount - slick.options.slidesToShow));
      $slider.slick('slickGoTo', Math.round(percent * maxIndex));
    }

    $thumb.on('mousedown touchstart', function (e) {
      isDragging = true;

      startX = e.type.includes('touch')
        ? e.originalEvent.touches[0].clientX
        : e.clientX;

      startLeft = parseFloat($thumb.css('left')) || 0;

      e.preventDefault();
    });

    $(document).on('mousemove touchmove', function (e) {
      if (!isDragging) return;

      const clientX = e.type.includes('touch')
        ? e.originalEvent.touches[0].clientX
        : e.clientX;

      const delta = clientX - startX;

      const trackWidth = $track.width();
      const thumbWidth = $thumb.width();
      const maxMove = Math.max(0, trackWidth - thumbWidth);

      let newLeft = startLeft + delta;
      newLeft = Math.max(0, Math.min(maxMove, newLeft));

      const percent = maxMove > 0 ? newLeft / maxMove : 0;
      goToPercent(percent);
    });

    $(document).on('mouseup touchend', function () {
      isDragging = false;
    });

    // Track click
    $track.on('click', function (e) {
      if ($(e.target).is('.scroll-thumb')) return;

      const offset = $track.offset();
      const trackWidth = $track.width();

      let percent = (e.clientX - offset.left) / trackWidth;
      percent = Math.max(0, Math.min(1, percent));

      goToPercent(percent);
    });
  }

  // ==========================
  // Init all sliders
  // ==========================
  function initAllSliders() {
    $('.related-product-slider').each(function () {
      initSlider($(this));
    });
  }

  // ==========================
  // Shopify AJAX support
  // ==========================
  const observer = new MutationObserver(initAllSliders);
  observer.observe(document.body, { childList: true, subtree: true });

  $(document).ready(initAllSliders);

})();